var chuck_img = {'image': 'https://cdn.shopify.com/s/files/1/0299/5411/3669/t/11/assets/chuck-in-cart-no-bubbles.png?v=2441228424905278583'};
var fby_min = 2;

var atccb_the_host = window.location.hostname;
var atccb_api_host = atccb_the_host.includes('dev') ? 'staging' : 'production';
var atccb_api_base = `https://${atccb_api_host}.tezcatlipoca.apps.creativity.inc/s/atc`;
var drawer_recent_prod_id;

// Put your application javascript here //

// Watch for zowie-chat-bar and change z-index
function applyZowieZIndex() {
    const host = document.querySelector('zowie-widget');
    if (!host) return false;

    const sr = host.shadowRoot;
    if (!sr) return false;

    const bar = sr.getElementById('zowie-chat-bar');
    if (!bar) return false;

    bar.style.setProperty('z-index', '8000', 'important');
    return true;
}

// First try immediately
if (!applyZowieZIndex()) {
    // Watch the main document for zowie-widget to be inserted
    const docObserver = new MutationObserver(() => {
        const host = document.querySelector('zowie-widget');
        if (!host) return;

        // Once the host exists, watch its shadow root for the button
        const srObserver = new MutationObserver(() => {
            if (applyZowieZIndex()) srObserver.disconnect();
        });
        srObserver.observe(host.shadowRoot, { childList: true, subtree: true, attributeFilter: ['style'] });

        docObserver.disconnect();
    });

    docObserver.observe(document.body, { childList: true, subtree: true });
}

// Cart Counter
// ----------------------------------------------------------------------------------------
function updateCartCounter(cart = CartJS.cart) {
  
    let item_count = 0;
    const sku_check = ['FBY', 'MQ', 'TRIM', 'QB'];
    
    for (let i = 0; i < cart?.items?.length; i++) {
        const item = cart.items[i];
        
        let sku_found = 0;
        
        for (let sku = 0; sku < sku_check.length; sku++) {
            const sku_item = sku_check[sku];
            sku_found = sku_found + item.sku.includes(sku_item)
        }

        ( sku_found ) ? item_count++ : item_count = item_count + item.quantity;
        
        // if (item.sku.includes('FBY') && item.quantity < fby_min) {
        //     CartJS.updateItemById(item.key, item.quantity, item.properties, item.options);
        // }
    }
    if(item_count) {
        // Update all locations of cart icon to display count of items in cart
        document.querySelectorAll('.cart-item-count').forEach(i => {
            i.innerText = item_count
            i.classList.remove('hidden');
        });
    }else{
        // Update all locations of cart icon to hide count badge
        document.querySelectorAll('.cart-item-count').forEach(i => {
            i.classList.add('hidden');
        });
    }

    if(item_count <= 0) {
        document.querySelectorAll('.cart-item-count').forEach( el => {
            el.classList.add('hidden');
        });
        if($('#cart-summary-scroll').length > 0) {
          document.getElementById('cart-summary-scroll').classList.add('hidden', 'opacity-0');
        }
    }
}

// Update cart badge count on load
// ----------------------------------------------------------------------------------------
$(document).ready(function(){
    updateCartCounter();
});

// Add item to cart on click
// ----------------------------------------------------------------------------------------
function addToCart(item_id, item_qty = 1, properties = {}, add_src = false, atccb = false) {
    if(CartJS.item_count === 0 && CartJS.attributes._bundle_bound){
        CartJS.setAttributes({
            '_bundle_bound': '',
            '_bundle_total': ''
        });
        CartJS.setNote(null);
        if(CartJS.getAttributes().hasOwnProperty('_bundle_bound')) {
            properties = {...properties, ...{'_bundle_bound': 'true'}};
        }
    }
    
    CartJS.addItem(item_id, item_qty, properties,
        {
            "success": function(data, textStatus, jqXHR) {
                updateCartCounter();
              
                dataLayer.push({'event': 'AddToCart'});
                if(add_src) gtag('event', add_src);

                if(document.getElementById('drawer-curtain') !== null){
                    drawer_recent_prod_id = item_id;
                    showDrawer(item_id);
                  
                }else{
                    notification(textStatus, data.title + ' has been added to your cart.', data);
                }
                if (dd_page === false && !data.sku?.includes('SUB')) {
                    $('.new_add_to_cart[type="submit"]').text('Update'); // added to cart
                }
              
                if(atccb !== false) {
                    $.ajax({
                        url: `${atccb_api_base}?${atccb}`,
                        method: 'GET'
                    }).done(function (response) {
                        return response;
                    }).fail(function (error) {
                        console.error(error);
                    });
                }
            },
            "error": function(jqXHR, textStatus, errorThrown){
                if(jqXHR.responseJSON.description !== null){
                  notification(textStatus, jqXHR.responseJSON.description, chuck_img);
                } else {
                  notification(textStatus, jqXHR.responseJSON.message, chuck_img);
                }
            }
        }
        
    );
}

// Update an item already in the cart
function updateCartItem(item, qty, props = {}) {
    CartJS.updateItemById(
        item.key, qty, props,
        {
            "success": function(data, textStatus, jqXHR){
                updateCartCounter();

                if(document.getElementById('drawer-curtain') !== null){
                    drawer_recent_prod_id = item.id;
                    showDrawer(item.id);
                }else{
                    notification(textStatus, item.product_title + ' has been updated in your cart.', data.items.find(item => item.variant_id === item.id))
                }
                
            },
            "error": function(jqXHR, textStatus, errorThrown){
                if(jqXHR.responseJSON.description !== null){
                  notification(textStatus, jqXHR.responseJSON.description, chuck_img);
                } else {
                  notification(textStatus, jqXHR.responseJSON.message, chuck_img);
                }
            }
        }
    );
}

/* Working on a solution to add multiple items in a single click */
function addGroupToCart(){
    let cartItems = [];

    document.getElementById('msqc-fproducts').children.forEach(i => { 
        if (i.dataset.available == 'true') {
            let jsonData = {}; 
            jsonData.id = parseInt(i.dataset.productid); 
            jsonData.quantity = parseInt(i.dataset.quantity); 
            cartItems.push(jsonData);
        }
    });

    CartJS.addItems(
        cartItems,
        {
            "success": function(data, textStatus, jqXHR) {
                notification(textStatus, 'All the available supplies have been added to your cart.', chuck_img);
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                if(jqXHR.responseJSON.description !== null){
                  notification(textStatus, jqXHR.responseJSON.description, current_item);
                } else {
                  notification(textStatus, jqXHR.responseJSON.message, current_item);
                }
            }
        }
    );    
}

// Toggle Transcript Collapsing
// ----------------------------------------------------------------------------------------
function toggleTranscript(e) {
    document.querySelector('#p_transcript').classList.toggle('h-64');

    if (document.getElementById('p_transcript').classList.contains('h-64')){
        document.getElementById('p_collapse').text = 'Read more';
    } else {
        document.getElementById('p_collapse').text = 'Read less';
    }
    
}

// ----------------------------------------------------------------------------------------
$(document).on('cart.requestStarted', function(e, c){
  if ($('#cart_spinner').length) {
      $('#cart_spinner').addClass('animate-spin');
      notification('success', 'Your cart is being updated', chuck_img);
  }
});

$(document).on('cart.requestComplete', function(e, c) {
  updateCartCounter(c);

  if(typeof Zowie !== 'undefined'){
      Zowie.updateCart();
  }

  if (typeof window.loyaltylion != "undefined" && typeof window.loyaltylion.ui != "undefined") {
      window.loyaltylion && window.loyaltylion.ui.refresh();
  }

  if (typeof free_shipping_countdown === 'function') {
      free_shipping_countdown(c);
  }

  if ($('#cart_spinner').length) {
      $('#cart_spinner').removeClass('animate-spin');
  }

  if(typeof drawDrawer !== 'undefined' && drawer_recent_prod_id){
      drawDrawer(drawer_recent_prod_id);
  }

  if(typeof updateLLPoints !== 'undefined'){
      updateLLPoints(c);
  }

  // check if cart is empty, remove bundle_bound checks
  if(c.item_count === 0 && c.attributes._bundle_bound){
      CartJS.setAttributes({
          '_bundle_bound': '',
          '_bundle_total': ''
      });
      CartJS.setNote(null);
  }
}); 

// Add to cart notification
// ----------------------------------------------------------------------------------------
function notification(type, title, product) {
    
    let hasTime = null;

    let toast_id = `toast-${Math.random().toString(36).slice(2)}`;

    const default_zindex = 1000000099;
    let toast_z = default_zindex + parseInt($('.toaster').length);

    let exclude_from_cart = "";
    if(window.location.href.indexOf('cart') === -1){
        exclude_from_cart = `<div class="text-sm"><a href="/cart" class="text-orange hover:text-underline">View your cart</a></div>`;
    }

    // build div
    $(`<div id="${toast_id}" class="toaster animate__animated hidden fixed bottom-0 w-full md:w-auto md:right-0 md:mb-8 md:mr-8 md:shadow-xl md:rounded-lg bg-white" style="z-index: ${toast_z};">
        <div class="toast_box flex justify-start items-center ml-0 sm:px-4 sm:py-4 md:pr-0 md:pl-0 md:py-0 border-l-8 md:border-l-4 md:border-r-4 md:rounded-lg">
            <img src="${product.image}" alt="${product.title}" class="h-24 w-auto p-3 rounded-l-8" />
            <div class="ml-4">
                <div class="toast_title">${title}</div>
                <div class="toast_cart_info mt-2 text-xs"><span class="toast-cart-total">{ cart.total }</span> x <span class="cart-item-count">{ cart.items }</span> items</div>
                ${exclude_from_cart}
            </div>
            <div class="toast_close self-stretch px-2 ml-4">&nbsp;</div>
        </div>
    </div>`).prependTo('body');
    
    $(`#${toast_id} .toast-cart-total`).text(Shopify.formatMoney(CartJS.cart.total_price)); // Show cart total

    // Set notification colors
    if( type === 'success') {
        $(`#${toast_id} .toast_box`).removeClass('border-red').addClass('border-aqua');
        $(`#${toast_id} .toast_cart_info`).hide();
    } else {
        $(`#${toast_id} .toast_box`).removeClass('border-aqua').addClass('border-red');
        $(`#${toast_id} .toast_cart_info`).hide();
    }

    const toaster = document.querySelector(`#${toast_id}`);

    // Show notification
    if (toaster.classList.contains('hidden') || toaster.classList.contains('animate__fadeOutRight')) {
        // remove classes and show toaster
        toaster.classList.add('animate__fadeInRight');
        toaster.classList.remove('hidden', 'animate__fadeOutRight');
        
        if(hasTime != null){
            clearTimeout(hasTime)
        }
        // hide notification
        hasTime = setTimeout(function() {
            toaster.classList.remove('animate__fadeInRight');
            toaster.classList.add('animate__fadeOutRight');

            toaster.addEventListener('animationend', () => {
                $(`#${toast_id}`).remove();
            });
            return false;
        }, 5000);
    }
}
